<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
      <FormItem v-for="(c, i) in formCtrl.slice(0, 1)" :key="'formItem' + i" :viewMode="viewMode" :config="c"
        :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

      <FormItem v-show="showLicense" :viewMode="licenseCtrl.viewMode" :config="licenseCtrl"
        :inputValue="form[licenseCtrl.keyName]" />

      <FormItem v-for="(c, i) in formCtrl.slice(1, 5)" :key="'formItem1' + i" :viewMode="viewMode" :config="c"
        :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
      <div>
        <FormItem v-for="(c, i) in formCtrl.slice(5)" :key="'formItem2' + i" :viewMode="viewMode" :config="c"
          :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
      </div>
    </el-form>

    <div class="btns">
      <el-button @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import mixin from "./mixin";

export default {
  mixins: [detailMixin, mixin],
  data() {
    return {
      viewMode: true,
      baseUrl: 'trailer',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/hang` },
        { name: "挂车管理", path: `/vehicle/hang` },
        { name: "挂车查看" },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    // border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .el-form-item__content {
      .el-input {
        width: 300px;
      }

      .el-input.upload {
        width: 100%;
        min-width: 300px;
      }

    }
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
